export const enClientPortalAssetDeviationAnalysis = {
    emptyStateTitle: 'There are not enough valuations available for this asset yet.',
    energyInfoBox: {
        condensedTitle: 'Energy key figures',
        spaciousSectionLabel: 'ESG',
        spaciousTitle: 'Energy values',
        labels: {
            primaryPowerConsumption: 'Primary energy consumption',
        },
        units: {
            primaryPowerConsumption: 'kWh/m²/year',
            carbonDioxideEquivalent: 'kg',
        },
        fuelTypeLabels: {
            wood: 'Wood',
            gas: 'Gas',
            oil: 'Oil',
            environmentalSoil: 'Ambient heat (ground)',
            environmentalAir: 'Ambient heat (air)',
            environmentalSolar: 'Ambient heat (solar thermal)',
            electricPower: 'Electricity',
            erdgas: 'Natural gas',
            fluessiggas: 'LPG',
            heizoelEl: 'Heating oil',
            strom: 'Electricity',
            nahFernwaerme: 'Local/district heating',
            holzpellets: 'Wood pellets',
            holzhackschnitzel: 'Wood chips',
            stueckholz: 'Firewood',
            waermepumpe: 'Heat pump',
            solarthermie: 'Solar thermal',
            geothermie: 'Geothermal',
            umweltwaerme: 'Ambient heat',
            hybridSystem: 'Hybrid system',
            biogasBiomethan: 'Biogas',
            steinkohle: 'Hard coal',
            braunkohle: 'Lignite',
        },
    },
}
